// Señal para layout/theme.liquid: el guion ha llegado y se encarga de mostrar.
window.shReveal = true;

function shInitReveal() {
  var items = document.querySelectorAll('.sh-reveal');
  if (!items.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('sh-visible'); });
    return;
  }
  // Escalonado por tanda y por sección: lo que entra a la vez en una misma
  // sección aparece en cascada (hasta 5 pasos de 90 ms); lo que entra después
  // no hereda esperas de otras secciones.
  var observer = new IntersectionObserver(
    function (entries) {
      var porSeccion = new Map();
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var seccion = entry.target.closest('.shopify-section') || document.body;
        var paso = porSeccion.get(seccion) || 0;
        entry.target.style.setProperty('--sh-i', Math.min(paso, 5));
        porSeccion.set(seccion, paso + 1);
        entry.target.classList.add('sh-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15 }
  );
  items.forEach(function (el) { observer.observe(el); });
}

function shInitCountUp() {
  var els = document.querySelectorAll('[data-sh-count]');
  if (!els.length) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseInt(el.getAttribute('data-sh-count'), 10) || 0;
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          el.textContent = Math.floor(progress * target);
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target;
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.5 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

// Vídeos que se mueven solos (p. ej. el cambio en sh-pasos): no se descargan
// hasta acercarse a la pantalla, se paran al salir de ella y tienen botón de
// pausa. Si el visitante pide menos movimiento, se quedan en la portada hasta
// que pulse reproducir.
function shInitVideos() {
  var videos = document.querySelectorAll('video[data-sh-video]');
  if (!videos.length) return;
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  videos.forEach(function (video) {
    var boton = video.parentNode.querySelector('[data-sh-video-boton]');
    var cargado = false;
    var paradoAMano = quieto;

    function cargar() {
      if (cargado) return;
      cargado = true;
      video.querySelectorAll('source[data-src]').forEach(function (fuente) {
        fuente.src = fuente.getAttribute('data-src');
      });
      video.load();
    }
    function reproducir() {
      cargar();
      var intento = video.play();
      if (intento && intento.catch) intento.catch(marcar);
    }
    function marcar() {
      if (!boton) return;
      var parado = video.paused;
      boton.setAttribute('data-estado', parado ? 'pausado' : 'reproduciendo');
      boton.setAttribute('aria-label', boton.getAttribute(parado ? 'data-texto-reproducir' : 'data-texto-pausar'));
    }

    video.addEventListener('play', marcar);
    video.addEventListener('pause', marcar);
    if (boton) {
      boton.addEventListener('click', function () {
        if (video.paused) {
          paradoAMano = false;
          reproducir();
        } else {
          paradoAMano = true;
          video.pause();
        }
      });
    }

    if (!('IntersectionObserver' in window)) {
      if (!quieto) reproducir();
      return;
    }
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!paradoAMano) reproducir();
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    ).observe(video);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  shInitReveal();
  shInitCountUp();
  shInitVideos();
});
